
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps, GetStaticPropsContext } from 'next';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Review } from 'shared/api/latestReviews';
import Page from 'shared/components/Page';
import useTranslation from 'shared/hooks/useTranslation';
import getReviews from 'lib/cache/latestReviews/reviews';
import Contact from 'modules/pricing/Contact';
import dynamic from 'next/dynamic';
import Head from 'next/head';
const PlansSection = dynamic(() => import('modules/pricing/PlansSection'));
const Integrations = dynamic(() => import('modules/pricing/Integrations'));
const PackageComparison = dynamic(() => import('modules/pricing/PackageComparison'));
const FAQ = dynamic(() => import('modules/pricing/FAQ'));
type PricingPageProps = {
    latestReviews: Review[];
};
const MediaWrapper = styled.div `
  display: none;

  ${({ theme }) => theme.MEDIA.XL} {
    display: block;
  }
`;
function PricingPage({ latestReviews }: PricingPageProps): JSX.Element {
    const { t } = useTranslation('pricingPage');
    const contactRef = useRef<HTMLDivElement>(null);
    const [scrollToContact, setScrollToContact] = useState(false);
    useEffect(() => {
        if (scrollToContact && contactRef.current) {
            contactRef.current.scrollIntoView({ block: 'center', behavior: 'smooth' });
            setScrollToContact(false);
        }
    }, [scrollToContact]);
    return (<Page reviews={latestReviews}>
      <Head>
        <title>{t('titleTag')}</title>
      </Head>
      <PlansSection onContactClick={() => setScrollToContact(true)}/>
      <Integrations />
      <Contact ref={contactRef}/>
      <FAQ />
      <MediaWrapper>
        <PackageComparison onContactClick={() => setScrollToContact(true)}/>
      </MediaWrapper>
    </Page>);
}
const getStaticProps: GetStaticProps<PricingPageProps> = async (context: GetStaticPropsContext) => {
    const latestReviews = await getReviews({
        language: context.locale as string,
    });
    return {
        props: { latestReviews },
        revalidate: 60,
    };
};
export default PricingPage;

    async function __Next_Translate__getStaticProps__1972058d334__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pricing',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1972058d334__ as getStaticProps }
  